const PREFIX = '@@LAYERS';

export const UPDATE_LAYER = `${PREFIX}/UPDATE_LAYER`;
export const FETCHED_LAYERS = `${PREFIX}/FETCHED_LAYERS`;
export const DELETE_LAYER = `${PREFIX}/DELETE_LAYER`;
export const START_LOADING_LAYERS = `${PREFIX}/START_LOADING_LAYERS`;
export const END_LOADING_LAYERS = `${PREFIX}/END_LOADING_LAYERS`;
export const CREATE_LAYER = `${PREFIX}/CREATE_LAYER`;
